<template>
	<div class="task-list-view">
		<div class="task" v-for="(task, i) in value" v-bind:key="i" @click="open(i)">
			{{ task.num ? '#' + task.num : 'Ny' }}, {{ _types.hasOwnProperty(task.type) ? _types[task.type].label : '-' }}<br>
			<span v-if="task.hour_rate == 0">Fastpris<br></span>
			<span v-if="task.hour_rate != 0">Timepris: {{ task.hour_rate | number }}<br></span>
			<span v-if="getTime(task)">Beregnede timer: {{ getTime(task) / 60.0 | roundHours | formatHours }}<br></span>
			<span v-if="!getTime(task)">Beregnede timer: [ IKKE BEREGNET ]<br></span>
			<span v-for="(pay, j) in getPayments(task)" :key="'pay-' + j">Betaling: {{ pay.amount | number }} ({{ pay.method }})<br></span>
			<span v-for="(comment, j) in getComments(task)" :key="'comment-' + j">"{{ comment.message }}" - {{ comment.name }}<br></span>
			<span v-for="(emp, j) in getBookings(task)" :key="'book-' + j">{{ emp.name }}: <span style="font-size: 12px;"  v-if="emp.time !== null">{{ emp.time | roundHours | formatHours }}</span><span style="font-size: 12px;" v-if="emp.time === null">[ IKKE OPLYST ]</span><br></span>
			<span>{{ task.due_start + ' ' + task.from | timestamp }}</span>
			<div>
				<div @click.stop="copy(i)">Kopi</div>
				<div @click.stop="remove(i)">Slet</div>
			</div>
		</div>
		<div class="btn" @click.stop="select">Tilføj</div>
	</div>
</template>

<script>
	import ContextPopupView from './ContextPopupView'

	import MoveTaskWindow from '../windows/MoveTaskWindow'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'
	import CourierTaskWindow from '../windows/CourierTaskWindow'
	import TaskWindow from '../windows/TaskWindow'

	import MoveTaskModel from '../model/MoveTask'
	import SurveyTaskModel from '../model/SurveyTask'
	import CourierTaskModel from '../model/CourierTask'
	import TaskModel from '../model/Task'
	//import Sur from '../windows/MoveTaskWindow'



	

	import merge from '../functions/merge'

	export default {
		data() {
			return {
				models: {
					'MoveTaskModel': MoveTaskModel,
					'SurveyTaskModel': SurveyTaskModel,
					'CourierTaskModel': CourierTaskModel,
					'TaskModel': TaskModel
				},
				windows: {
					'MoveTaskWindow': MoveTaskWindow,
					'SurveyTaskWindow': SurveyTaskWindow,
					'CourierTaskWindow': CourierTaskWindow,
					'TaskWindow': TaskWindow
				},
				types: []
			};
		},
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			},
			mask: {
				type: Array,
				default() {
					return ['move', 'survey', 'compound', 'courier'];
				}
			},
			template: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		computed: {
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				

				return r;
			},
			_actions() {
				var r = [];
				var self = this;
			//	var always = true;

				for (var i = 0; i < this.types.length; ++i) {
					if (this.$store.getters.taskTypes.includes(this.types[i].name)) {
						r.push({
							label: self.types[i].label,
							action: (function () {
								var j = i;

								return function () {
									//
									//
									self.create(self.types[j], self.template);	
								}
							})()
						});
					}
				}

				return r;
			}
		},
		methods: {
			getTime(task) {
				if (task.hasOwnProperty('_embedded') && task._embedded.hasOwnProperty('time')) {
					return task._embedded.time;
				}

				return null;
			},
			getPayments(task) {
				if (task.hasOwnProperty('_embedded') && task._embedded.hasOwnProperty('payments')) {
					return task._embedded.payments;
				}

				return [];
			},
			getComments(task) {
				if (task.hasOwnProperty('_embedded') && task._embedded.hasOwnProperty('comments')) {
					return task._embedded.comments;
				}

				return [];
			},
			getBookings(task) {
				if (task.hasOwnProperty('_embedded') && task._embedded.hasOwnProperty('bookings')) {
					return task._embedded.bookings.employees;
				}

				return [];
			},
			select() {
				

				

				/*if (this.mask.length == 1) {
					this.create(this.mask[0], this.template);
					return;
				}*/

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: this._actions
				});
			},
			remove(i) {
				
				var value = Array.from(this.value);
				value.splice(i, 1);
				this.$emit('input', value);
			},
			open(i) {
				
				//this.create(this.value[i].type, this.value[i]);

	
				var task = this.value[i];
				task._index = i;

				this.create(this._types[task.type], task);
			},
			copy(i) {
				
				//this.create(this.value[i].type, this.value[i]);

	
				var tasks = Array.from(this.value);
				var task = merge({}, this.value[i]);
				delete task.id;

				tasks.push(task);
				//task._index = i;

				//this.value = tasks;
				this.$emit('input', tasks);
			},
			create(type, template) {
				

				var self = this;

				
				

				var ent = merge(self.models[type.model].entity(), template);
				ent.type = type.name;

				self.$store.state.windowStack.push(this.windows[type.window], {
					value: ent,
					async submit(entity) {
						

						var value = Array.from(self.value);
						
						if (entity.hasOwnProperty('_index')) {
							value[entity._index] = merge(value[entity._index], entity);
						} else {
							value.push(entity);	
						}

						self.$emit('input', value);
						self.$store.state.windowStack.pop();
					}
				});

				/*if (type == 'move') {
					self.$store.state.windowStack.push(MoveTaskWindow, {
						entity: merge(MoveTaskModel.entity(), template),
						async submit(entity) {
							

							var value = Array.from(self.value);
							
							if (entity.hasOwnProperty('_index')) {
								value[entity._index] = merge(value[entity._index], entity);
							} else {
								value.push(entity);	
							}

							self.$emit('input', value);
							self.$store.state.windowStack.pop();
						}
					});
				}

				if (type == 'survey') {
					self.$store.state.windowStack.push(SurveyTaskWindow, {
						entity: merge(SurveyTaskModel.entity(), template),
						async submit(entity) {
							var value = Array.from(self.value);
							
							if (entity.hasOwnProperty('_index')) {
								value[entity._index] = merge(value[entity._index], entity);
							} else {
								value.push(entity);	
							}

							self.$emit('input', value);
							self.$store.state.windowStack.pop();
						}
					});
				}

				if (type == 'compound') {
					self.$store.state.windowStack.push(CompoundTaskWindow, {
						entity: merge(CompoundTaskModel.entity(), template),
						async submit(entity) {
							var value = Array.from(self.value);
							
							if (entity.hasOwnProperty('_index')) {
								value[entity._index] = merge(value[entity._index], entity);
							} else {
								value.push(entity);	
							}

							self.$emit('input', value);
							self.$store.state.windowStack.pop();
						}
					});
				}

				if (type == 'courier') {
					self.$store.state.windowStack.push(CourierTaskWindow, {
						entity: merge(CourierTaskModel.entity(), template),
						async submit(entity) {
							var value = Array.from(self.value);
							
							if (entity.hasOwnProperty('_index')) {
								value[entity._index] = merge(value[entity._index], entity);
							} else {
								value.push(entity);	
							}

							self.$emit('input', value);
							self.$store.state.windowStack.pop();
						}
					});
				}*/
			}
		},
		mounted() {
			var self = this;

			

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
					//self.departments = r.data._items;
				});
		}
	}
</script>

<style lang="scss" scoped>
	.task-list-view {
		overflow: hidden;

		& > input {
			position: absolute;
			left: -500px;
		}

		& > .task {
			position: relative;
			border: 1px solid #2d2f36;
			line-height: 30px;
			text-align: left;
			padding: 5px 0 5px 10px;
			margin-bottom: 10px;
			cursor: pointer;

			& > span {
				font-size: 12px;
			}

			& > div {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 15px;
					font-size: 12px;
				}
			}
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>